import { render, staticRenderFns } from "./DriverInfoModal.vue?vue&type=template&id=f0f1d5a6&scoped=true&"
import script from "./DriverInfoModal.vue?vue&type=script&lang=js&"
export * from "./DriverInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./DriverInfoModal.vue?vue&type=style&index=0&id=f0f1d5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f1d5a6",
  null
  
)

export default component.exports